import { NgModule } from '@angular/core';
import { TooltipIfTruncatedDirective } from './tooltip-if-truncated.directive';

@NgModule({
    declarations: [TooltipIfTruncatedDirective],
    exports: [TooltipIfTruncatedDirective],
})
export class TooltipIfTruncatedModule {}
